export default __webpack_public_path__ + "static/white-w-chckup-63ca0fa9f9503f6cc0fa61e650681162.png";